import React, { createContext, useContext, ReactNode } from 'react';
import { AdDetails } from '@/api/types/ads.types';

interface ServerDataContextProps {
  initialAdDetails: AdDetails | null;
}

const ServerDataContext = createContext<ServerDataContextProps | undefined>(
  undefined
);

export const ServerDataProvider = ({
  children,
  adDetails,
}: {
  children: ReactNode;
  adDetails: AdDetails | null;
}) => {
  return (
    <ServerDataContext.Provider value={{ initialAdDetails: adDetails }}>
      {children}
    </ServerDataContext.Provider>
  );
};

export const useServerDataContext = () => {
  const context = useContext(ServerDataContext);
  if (!context) {
    throw new Error(
      'useServerDataContext must be used within InitialDataProviderProvider'
    );
  }
  return context;
};
